var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1 6.75H10.0625V10.08L11.615 8.5275C11.7275 8.415 11.87 8.3625 12.0125 8.3625C12.155 8.3625 12.2975 8.415 12.41 8.5275C12.6275 8.745 12.6275 9.105 12.41 9.3225L9.8975 11.835C9.68 12.0525 9.32 12.0525 9.1025 11.835L6.59 9.3225C6.3725 9.105 6.3725 8.745 6.59 8.5275C6.8075 8.31 7.1675 8.31 7.385 8.5275L8.9375 10.08V6.75H5.9C3.5 6.75 2 8.25 2 10.65V12.5925C2 15 3.5 16.5 5.9 16.5H13.0925C15.4925 16.5 16.9925 15 16.9925 12.6V10.65C17 8.25 15.5 6.75 13.1 6.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 2.0625C10.0625 1.755 9.8075 1.5 9.5 1.5C9.1925 1.5 8.9375 1.755 8.9375 2.0625V6.75H10.0625V2.0625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIc);
export default __webpack_public_path__ + "static/media/download-ic.701150be34e196768fb160994367e30a.svg";
export { ForwardRef as ReactComponent };